import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TimerMode } from '../../../const/timer';
import ChgkTimer from './ChgkTimer';

const Timer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ChgkTimer
      variant="fullscreen"
      title="NHN Taymer · 3sual"
      initialMode={TimerMode.QUESTION}
      durations={{
        questionSeconds: 60,
        dupletSeconds: 30,
        blitzSeconds: 20,
        blitzSteps: 3,
      }}
      enableKeyboardShortcuts
      enableSoundCue
      onClose={() => navigate(-1)}
    />
  );
};

export default Timer;
